import type { Mark } from '@gitbook/slate';

/**
 * Create the inline style for a MARK_COLOR
 */
export function formatMarkColorStyle(mark: Mark): string {
    let style = '';
    const textColor = mark.data.get('text', 'default');
    const backgroundColor = mark.data.get('background', 'default');
    style += textColor !== 'default' ? `color:${textColor};` : '';
    style += backgroundColor !== 'default' ? `background-color:${backgroundColor};` : '';

    return style;
}
